<template>
  <v-generic-input
    :label="label"
    :translate-text="translateText"
    :help-text="helpText"
    :id="`${givenId}`"
    :required="required"
    :errors="errors"
  >
    <template v-slot:input>
      <v-date-dropdown
        :minDate="minDateString"
        :maxDate="maxDateString"
        :defaultDate="defaultDate"
        v-model="inputVal"
        dropdown-class="form-control"
        wrapper-class="d-flex"
        :day-suffix-values="['', '', '', '']"
        :day-label="$tc('word.day', 1)"
        :month-label="$t('word.month')"
        :year-label="$t('word.year')"
        :month-long-values="monthLongValues"
        displayFormat="dmy"
      />
    </template>
  </v-generic-input>
</template>

<script>
import DateDropdown from 'vue-dropdown-datepicker';
import { GenericInputMixin } from '@/common/utils/mixins';
import { toFormattedDate } from '@/common/utils/formatting';
import _GenericInput from './_GenericInput.vue';

export default {
  name: 'DateInput',
  components: {
    'v-generic-input': _GenericInput,
    'v-date-dropdown': DateDropdown,
  },
  props: {
    minDate: {
      type: Date,
    },
    maxDate: {
      type: Date,
    },
    value: {
      type: Date,
      default() {
        return null;
      },
    },
  },
  mixins: [
    GenericInputMixin,
  ],
  computed: {
    maxDateString() {
      return toFormattedDate(this.maxDate);
    },
    minDateString() {
      return toFormattedDate(this.minDate);
    },
    inputVal: {
      get() {
        return toFormattedDate(this.value);
      },
      set(val) {
        this.$emit('input', new Date(val));
      },
    },
  },
  data() {
    return {
      defaultDate: null,
      givenId: null,
      monthLongValues: [
        this.$t('time.month.january'),
        this.$t('time.month.february'),
        this.$t('time.month.march'),
        this.$t('time.month.april'),
        this.$t('time.month.may'),
        this.$t('time.month.june'),
        this.$t('time.month.july'),
        this.$t('time.month.august'),
        this.$t('time.month.september'),
        this.$t('time.month.october'),
        this.$t('time.month.november'),
        this.$t('time.month.december'),
      ],
    };
  },
  mounted() {
    // eslint-disable-next-line no-underscore-dangle
    this.givenId = this.id || this._uid;
  },
  created() {
    this.defaultDate = toFormattedDate(this.value);
  },
};
</script>
